import axios from "axios";

// URL Session
const getConfig = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return config;
};

export const deleteUrlSession = (url, callback) => {
  axios
    .delete(url, getConfig())
    .then((response) => {
      return callback(response.data);
    })
    .catch((error) => console.log(error));
};

export const getUrlSession = (url, callback, isBaseData) => {
  isBaseData = isBaseData || false;

  axios
    .get(url, getConfig())
    .then((response) => {
      const data = response.data;
      if (typeof data.errors !== "undefined") {
        return callback(null);
      }
      const _data = isBaseData ? data : data.data;
      return callback(_data);
    })
    .catch((error) => {
      console.log(error);
      callback(null, error);
    });
};

export const postUrlSession = (url, body, callback) => {
  axios
    .post(url, body, getConfig())
    .then((response) => {
      return callback(response.data.data);
    })
    .catch((error) => console.log(error));
};
